import { useInjectReducer } from "@app/store";
import PageContent from "@components/PageContent";
import PageHeader from "@components/PageHeader";
import shippingChargeSlice, {
  setQueryValue,
  setOneValue,
  addNewTypeObjectToArray,
  addObjectToArray,
  removeObjectFromArray,
  clearOne,
  removeNewTypeObjectToArray,
  setValueToArray,
} from "@features/admin/shipping/shippingCharge/shippingChargeSlice";
import {
  makeSelectOne,
  makeSelectWeightPrice,
} from "@features/admin/shipping/shippingCharge/shippingChargeSelector";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import InputWrapper from "@components/Input";
import Input from "@components/Input";

import SelectWrapper from "@components/Select";
import { useEffect, useState } from "react";
import {
  useAddEditShippingChargeMutation,
  useLoadAllStaticMutation,
  useLoadOneShippingChargeMutation,
} from "@features/admin/shipping/shippingCharge/shippingChargeApiSlice";
import { locationLevel } from "@utils/constants";
import Checkbox from "@components/Checkbox";
import Table from "@components/Table";
import { FaInfo, FaTrash } from "react-icons/fa";
import Select from "react-select";
import DeleteDialog from "@components/DeleteDialog";
import { enqueueSnackbar, makeSelectAccess } from "@features/auth/authSlice";
import Button from "@components/Button";
import ToolTip from "@components/Tooltip";
import { Tooltip } from "@mantine/core";

const options = [
  { label: locationLevel.level_1, name: "state" },
  { label: locationLevel.level_2, name: "district" },
  { label: locationLevel.level_3, name: "city" },
  { label: locationLevel.level_4, name: "area" },
];

const ShippingChargeAddEditPage = () => {
  useInjectReducer("shippingCharge", shippingChargeSlice);
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const one = useSelector(makeSelectOne);
  const weight_price = useSelector(makeSelectWeightPrice);
  const access = useSelector(makeSelectAccess);

  const [loadAllStatic, { data: loadAllStaticData }] =
    useLoadAllStaticMutation();

  const [
    loadOneShippingCharge,
    { data: loadOneShippingChargeData, isLoading: loading, isSuccess: success },
  ] = useLoadOneShippingChargeMutation();

  const [addEditShippingCharge, { isLoading: saveLoading }] =
    useAddEditShippingChargeMutation();

  useEffect(() => {
    if (id) {
      loadOneShippingCharge(id);
    } else {
      dispatch(clearOne());
    }
  }, []);

  useEffect(() => {
    loadAllStatic();
  }, []);

  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(false);
  const [error, setError] = useState();
  const [errorIndex, setErrorIndex] = useState([]);

  let listOptionNormalized = {};
  const listOption = options.map((each) => {
    let obj = {
      label: each.label,
      value: each.name,
    };
    listOptionNormalized = {
      ...listOptionNormalized,
      [each.name]: obj,
    };
    return obj;
  });

  let listStateNormalized = {};
  const listState = loadAllStaticData?.data?.allState.map((each) => {
    let obj = {
      label: each.name,
      value: each._id,
    };
    listStateNormalized = {
      ...listStateNormalized,
      [each._id]: obj,
    };
    return obj;
  });

  let listDistrictNormalized = {};
  const listDistrict = loadAllStaticData?.data?.allDistrict.map((each) => {
    let obj = {
      label: each.name,
      value: each._id,
    };
    listDistrictNormalized = {
      ...listDistrictNormalized,
      [each._id]: obj,
    };
    return obj;
  });

  let listCityNormalized = {};
  const listCity = loadAllStaticData?.data?.allVdc.map((each) => {
    let obj = {
      label: each.name,
      value: each._id,
    };
    listCityNormalized = {
      ...listCityNormalized,
      [each._id]: obj,
    };
    return obj;
  });

  let listAreaNormalized = {};
  const listArea = loadAllStaticData?.data.allArea.map((each) => {
    let obj = {
      label: each.name,
      value: each._id,
    };
    listAreaNormalized = {
      ...listAreaNormalized,
      [each._id]: obj,
    };
    return obj;
  });

  const handleCheckedChange = (name) => (event) => {
    dispatch(setOneValue({ key: name, value: event.target.checked }));
  };

  const handleChange = (name) => (event) => {
    dispatch(setOneValue({ key: name, value: event.target.value }));
  };

  const handlePopDialog = (id) => {
    setOpen(true);
    setDeleteId(id);
  };

  const handleDelete = (id) => {
    dispatch(removeObjectFromArray(id));
    setDeleteId(id);
  };

  const handleClosePopDialog = () => {
    setOpen(false);
  };

  const handleSave = () => {
    const data = { ...one };
    addEditShippingCharge(data)
      .unwrap()
      .then((res) => {
        if (res?.success) {
          dispatch(
            enqueueSnackbar({
              msg: res?.msg || "Shipping Charge Add Successful.",
              options: {
                variant: "success",
              },
            })
          );
          navigate("/admin/shipping-charge");
        }
      })
      .catch((err) => {
        if (err?.data?.msg) {
          dispatch(
            enqueueSnackbar({
              message: err?.data?.msg ?? "Something went wrong",
              options: {
                variant: "warning",
              },
            })
          );
        }
      });
  };

  const handleAddColumn = () => {
    const obj = {
      from: 0,
      to: 0,
      price: 0,
    };
    dispatch(addObjectToArray(obj));
  };

  const handleAddNewType = () => {
    const shipping_type = one.shipping_type || [];

    const date = new Date();
    const obj = {
      title: "",
      multiply_factor: 1,
      min_estimated_day: 1,
      max_estimated_day: 1,
      is_default: false,
    };
    if (shipping_type.length > 0) {
      dispatch(
        addNewTypeObjectToArray({
          key: "shipping_type",
          value: [...shipping_type, { ...obj }],
        })
      );
    } else {
      dispatch(
        addNewTypeObjectToArray({
          key: "shipping_type",
          value: [{ ...obj }],
        })
      );
    }
  };

  // const handleRemoveObjNewType = index => {
  //     removeNewType
  // }

  const handleChangeWeightPrice = (name, index) => (event) => {
    dispatch(
      setValueToArray({
        key: index,
        name: name,
        value: event.target.value,
      })
    );
    setErrorIndex([]);
    let pushError = [];
    weight_price.forEach((element, i) => {
      let x = { ...element };
      if (Number(index) == i) {
        x.to = Number(event.target.value);
      }
      if (Number(index + 1) == i) {
        x.from = Number(event.target.value);
      }
      if (name === "to") {
        if (x.to != null && Number(x.to) < Number(x.from)) {
          pushError.push(i);
          setError("Please enter greater than from value.");
          setErrorIndex(pushError);
        }
      }
    });
  };

  const handleShippingTypeChange = (name, index) => (event) => {
    dispatch(
      setOneValue({
        key1: "shipping_type",
        key2: name,
        index,
        value:
          name !== "is_default" ? event.target.value : event.target.checked,
      })
    );
  };

  const handleRemoveObjNewType = (index) => {
    dispatch(removeNewTypeObjectToArray(index));
  };

  const handleDropDownChange = (name) => (event) => {
    if (name === "set_by") {
      dispatch(setQueryValue({ key: name, value: event.value }));
    } else if (name === "state") {
      dispatch(
        setOneValue({ key: name, value: event.map((each) => each.value) })
      );
      dispatch(setOneValue({ key: "district", value: null }));
      dispatch(setOneValue({ key: "city", value: null }));
      dispatch(setOneValue({ key: "area", value: null }));
    } else if (name === "district") {
      dispatch(
        setOneValue({ key: name, value: event.map((each) => each.value) })
      );
      dispatch(setOneValue({ key: "state", value: null }));
      dispatch(setOneValue({ key: "city", value: null }));
      dispatch(setOneValue({ key: "area", value: null }));
    } else if (name === "city") {
      dispatch(
        setOneValue({ key: name, value: event.map((each) => each.value) })
      );
      dispatch(setOneValue({ key: "district", value: null }));
      dispatch(setOneValue({ key: "state", value: null }));
      dispatch(setOneValue({ key: "area", value: null }));
    } else if (name === "area") {
      dispatch(
        setOneValue({ key: name, value: event.map((each) => each.value) })
      );
      dispatch(setOneValue({ key: "district", value: null }));
      dispatch(setOneValue({ key: "city", value: null }));
      dispatch(setOneValue({ key: "state", value: null }));
    }
  };

  const shippingTypeTableData =
    one.shipping_type.length > 0
      ? one.shipping_type.map((each, index) => [
          <InputWrapper
            id='grid-logic-code'
            name='inputbox'
            type='string'
            value={each.title}
            className='w-40'
            onChange={handleShippingTypeChange("title", index)}
          />,
          <InputWrapper
            id='grid-logic-code'
            name='inputbox'
            type='number'
            value={each.multiply_factor}
            onChange={handleShippingTypeChange("multiply_factor", index)}
          />,
          <InputWrapper
            id='grid-logic-code'
            name='inputbox'
            type='number'
            value={each.min_estimated_day}
            onChange={handleShippingTypeChange("min_estimated_day", index)}
          />,
          <InputWrapper
            id='grid-logic-code'
            name='inputbox'
            type='number'
            value={each.max_estimated_day}
            onChange={handleShippingTypeChange("max_estimated_day", index)}
          />,
          <div className='flex mt-2 items-center'>
            <Checkbox
              label={"Default"}
              name={`is_default${index}`}
              onChange={handleShippingTypeChange("is_default", index)}
              checked={each.is_default || false}
            />
          </div>,
          <div className='flex mt-2 items-center'>
            <FaTrash
              className='text-red-500 cursor-pointer'
              onClick={() => handleRemoveObjNewType(index)}
            />
          </div>,
        ])
      : [];

  const tableData = weight_price
    ? weight_price.map(({ from, to, price }, index) => [
        <InputWrapper
          name='from'
          value={from || "0"}
          onChange={handleChangeWeightPrice("from", index)}
          placeholder='From (Weight in KG)'
          disabled
        />,
        <InputWrapper
          name='to'
          value={to === null ? "Infinity" : to}
          onChange={handleChangeWeightPrice("to", index)}
          disabled={index === weight_price.length - 1 ? true : false}
        />,
        <InputWrapper
          name='price'
          value={price}
          onChange={handleChangeWeightPrice("price", index)}
          placeholder='Price'
        />,
        <div className='flex mt-2 items-center'>
          <FaTrash
            className='text-red-500'
            onClick={() => handlePopDialog(index)}
          />
        </div>,
      ])
    : [];

  return (
    <>
      <DeleteDialog
        opened={open}
        doClose={handleClosePopDialog}
        doDelete={() => handleDelete(deleteId)}
      />
      <Helmet>
        <title> {id ? "Edit" : "Add"} Shipping Charge </title>
      </Helmet>
      <PageHeader
        title={id ? "Edit Shipping Charge" : "Add Shipping Charge"}
        isBack
        handleGoBack={() => navigate("/admin/shipping-charge")}
      />
      <PageContent loading={loading}>
        <div className='bg-white p-4 border'>
          <div className='w-full md:w-1/2 pb-4'>
            <InputWrapper
              label='Title'
              id='grid-title'
              name='title'
              type='text'
              value={one?.title || ""}
              onChange={handleChange("title")}
            />
          </div>
          <div className='w-full md:w-1/2 pb-4 relative'>
            <Input
              label='Priority'
              value={one?.priority || ""}
              id='grid-priority'
              name='priority'
              type='number'
              isTooltip
              toolTipContent='The higher the value, the higher the priority.'
              onChange={handleChange("priority")}
            />
          </div>
          <div className='w-full md:w-1/2 pb-4'>
            <InputWrapper
              label='Price'
              id='grid-price'
              name='price'
              type='number'
              value={one?.price || ""}
              onChange={handleChange("price")}
            />
          </div>
          <div className='w-full md:w-1/2 pb-4'>
            <InputWrapper
              label='Cart Amount for Free Shipping'
              id='grid-logic-code'
              name='free_shiping_price'
              type='number'
              value={one?.free_shipping_price || ""}
              onChange={handleChange("free_shipping_price")}
            />
          </div>
          ,
          <div className='w-full md:w-1/2'>
            <SelectWrapper
              label='Select Shipping Logic'
              placeholder='Choose Options'
              options={listOption}
              noOptionsMessage={() => "No View Available"}
              onChange={handleDropDownChange("set_by")}
              value={listOptionNormalized[one?.set_by]}
              divclassname='mb-4'
            />
          </div>
          <div className='w-full md:w-1/2 pb-4'>
            <div className='flex justify-between items-center'>
              <label className='font-bold text-gray-700 inline-flex items-center'>
                Shipping Type &nbsp;
                {/* check for error */}
              </label>
              <div>
                <button
                  type='button'
                  className='btn btn-waft mt-2 mb-2 bg-success'
                  onClick={handleAddNewType}
                >
                  Add New Type
                </button>
              </div>
            </div>
            <div>
              <Table
                tableHead={[
                  "Title",
                  "Multiply Factor",
                  "Min Estimated Day",
                  "Max Estimated Day",
                  "Status",
                  "Actions",
                ]}
                tableData={shippingTypeTableData || []}
                ispublic
                isSN
              />
            </div>
          </div>
          {one?.set_by === "state" && (
            <div className='w-full md:w-1/2'>
              <label className='font-bold text-gray-700 inline-flex items-center'>
                Select {locationLevel.level_1}
              </label>
              <span className='mr-2'>
                <Select
                  placeholder='Choose Options'
                  options={listState}
                  value={
                    one?.state?.map((each, index) => {
                      const stateObj = listStateNormalized[each];
                      if (!stateObj) {
                        return {
                          label: "loading",
                          value: index,
                        };
                      }
                      return stateObj;
                    }) || []
                  }
                  onChange={handleDropDownChange("state")}
                  isMulti
                />
              </span>
            </div>
          )}
          {one?.set_by === "district" && (
            <div className='w-full md:w-1/2'>
              <label className='font-bold text-gray-700 inline-flex items-center'>
                Select {locationLevel.level_2}
              </label>
              <span className='mr-2'>
                <Select
                  placeholder='Choose Options'
                  options={listDistrict}
                  value={
                    one?.district?.map((each, index) => {
                      const disObj = listDistrictNormalized[each];
                      if (!disObj) {
                        return {
                          label: "loading",
                          value: index,
                        };
                      }
                      return disObj;
                    }) || []
                  }
                  onChange={handleDropDownChange("district")}
                  isMulti
                />
              </span>
            </div>
          )}
          {one?.set_by === "city" && (
            <div className='w-full md:w-1/2'>
              <label className='font-bold text-gray-700 inline-flex items-center'>
                Select {locationLevel.level_3}
              </label>
              <span className='mr-2'>
                <Select
                  placeholder='Choose Options'
                  options={listCity}
                  value={
                    one?.city?.map((each, index) => {
                      const cityObj = listCityNormalized[each];
                      if (!cityObj) {
                        return {
                          label: "loading",
                          value: index,
                        };
                      }
                      return cityObj;
                    }) || []
                  }
                  onChange={handleDropDownChange("city")}
                  isMulti
                />
              </span>
            </div>
          )}
          {one?.set_by === "area" && (
            <div className='w-full md:w-1/2'>
              <label className='font-bold text-gray-700 inline-flex items-center'>
                Select {locationLevel.level_4}
              </label>
              <span className='mr-2'>
                <SelectWrapper
                  placeholder='Choose Options'
                  options={listArea}
                  value={
                    one?.area?.map((each, index) => {
                      const areaObj = listAreaNormalized[each];
                      if (!areaObj) {
                        return {
                          label: "loading",
                          value: index,
                        };
                      }
                      return areaObj;
                    }) || []
                  }
                  onChange={handleDropDownChange("area")}
                  isMulti
                />
              </span>
            </div>
          )}
          <div className='w-full md:w-1/2 pb-4'>
            <Checkbox
              label={"Is Active"}
              name={"is_active"}
              onChange={handleCheckedChange("is_active")}
              checked={one.is_active || false}
            />
          </div>
          <div className='w-full md:w-1/2 pb-4'>
            <Checkbox
              label={"Use Weight"}
              name={"use_weight"}
              onChange={handleCheckedChange("use_weight")}
              checked={one.use_weight || false}
            />
          </div>
          {one.use_weight && (
            <div>
              <div>
                <button
                  type='button'
                  className='btn btn-waft bg-success mt-2 mb-2'
                  onClick={handleAddColumn}
                >
                  Add Weight Range and Price
                </button>
              </div>
              <div>
                <Table
                  tableHead={[
                    "From (Weight in KG)",
                    "Upto (Weight in KG)",
                    "Price",
                    "Actions",
                  ]}
                  tableData={tableData || []}
                  ispublic
                />
              </div>
            </div>
          )}
          <Button
            type='button'
            className={`${
              errorIndex.length !== 0 ? `Cursor-not-allowed` : ``
            } btn bg-success mt-5`}
            onClick={handleSave}
          >
            Save
          </Button>
        </div>
      </PageContent>
    </>
  );
};

export default ShippingChargeAddEditPage;
